/* eslint-disable react/no-unused-prop-types */
import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  stroke?: string;
  strokeWidth?: number;
  fill?: string;
  size?: number;
  customStyles?: any;
}

export const IconCode = ({ height = 24, width = 24, stroke = "#AB854A" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M10.7999 17.6969L13.1999 6.29688M5.9999 15.8969L2.3999 12.2969L5.9999 8.69688M17.9999 8.69688L21.5999 12.2969L17.9999 15.8969"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconAttachment = ({
  height = 24,
  width = 24,
  stroke = "#B0B0B0",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M7.37851 10.1868L5.14505 12.4203C4.31092 13.2544 3.83124 14.3894 3.84001 15.5822C3.84877 16.775 4.31796 17.9169 5.19167 18.7636C6.03836 19.6374 7.18048 20.1065 8.3731 20.1153C9.59293 20.1243 10.701 19.6716 11.5352 18.8375L13.7687 16.604M16.6215 13.8058L18.8549 11.5723C19.6891 10.7382 20.1688 9.60321 20.16 8.41039C20.1512 7.21758 19.682 6.07569 18.8083 5.22896C17.9618 4.38248 16.8199 3.91327 15.6271 3.9045C14.4343 3.89573 13.2992 4.34819 12.465 5.18234L10.2315 7.4158M8.6131 15.3235L15.3135 8.6231"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconGoToTab = ({
  height = 24,
  width = 24,
  stroke = "#444444",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M10.875 3H6.375C4.51104 3 3 4.51103 3 6.37498V17.625C3 19.489 4.51104 21 6.375 21H17.625C19.489 21 21 19.489 21 17.625V13.1249M15.3744 3.00027L21 3M21 3V8.06261M21 3L11.4367 12.5622"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconSettings = ({
  height = 24,
  width = 24,
  stroke = "#444444",
  color = "#fff",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M13.6763 4.31627C13.2488 2.56124 10.7512 2.56124 10.3237 4.31627C10.2599 4.57999 10.1347 4.82492 9.95831 5.03112C9.78194 5.23732 9.55938 5.39897 9.30874 5.50291C9.0581 5.60684 8.78646 5.65014 8.51592 5.62927C8.24538 5.60839 7.9836 5.52394 7.75187 5.38279C6.20832 4.44227 4.44201 6.20855 5.38254 7.75207C5.99006 8.74884 5.45117 10.0494 4.31713 10.325C2.56096 10.7514 2.56096 13.25 4.31713 13.6753C4.58093 13.7392 4.8259 13.8645 5.03211 14.041C5.23831 14.2175 5.39991 14.4402 5.50375 14.691C5.6076 14.9418 5.65074 15.2135 5.62968 15.4841C5.60862 15.7547 5.52394 16.0165 5.38254 16.2482C4.44201 17.7917 6.20832 19.558 7.75187 18.6175C7.98356 18.4761 8.24537 18.3914 8.51597 18.3704C8.78658 18.3493 9.05834 18.3924 9.30912 18.4963C9.5599 18.6001 9.7826 18.7617 9.95911 18.9679C10.1356 19.1741 10.2609 19.4191 10.3248 19.6829C10.7512 21.439 13.2499 21.439 13.6752 19.6829C13.7393 19.4192 13.8647 19.1744 14.0413 18.9684C14.2178 18.7623 14.4405 18.6008 14.6912 18.497C14.9419 18.3932 15.2135 18.35 15.4841 18.3709C15.7546 18.3919 16.0164 18.4764 16.2481 18.6175C17.7917 19.558 19.558 17.7917 18.6175 16.2482C18.4763 16.0165 18.3918 15.7547 18.3709 15.4842C18.35 15.2136 18.3932 14.942 18.497 14.6913C18.6008 14.4406 18.7623 14.2179 18.9683 14.0414C19.1744 13.8648 19.4192 13.7394 19.6829 13.6753C21.439 13.2489 21.439 10.7502 19.6829 10.325C19.4191 10.2611 19.1741 10.1358 18.9679 9.95928C18.7617 9.78278 18.6001 9.56007 18.4962 9.3093C18.3924 9.05853 18.3493 8.78677 18.3703 8.51617C18.3914 8.24556 18.4761 7.98376 18.6175 7.75207C19.558 6.20855 17.7917 4.44227 16.2481 5.38279C16.0164 5.52418 15.7546 5.60886 15.484 5.62992C15.2134 5.65098 14.9417 5.60784 14.6909 5.504C14.4401 5.40016 14.2174 5.23856 14.0409 5.03236C13.8644 4.82616 13.7391 4.58119 13.6752 4.3174L13.6763 4.31627ZM12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
      fill={color}
      stroke={stroke}
      fillRule="evenodd"
      clipRule="evenodd"
      strokeWidth="1.5"
    />
  </svg>
);

export const IconEye = ({
  height = 24,
  width = 24,
  stroke = "#444444",
  fill = "none",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9999 18.8534C19.323 18.9731 21.5999 12.1168 21.5999 12.1168C21.5999 12.1168 19.4153 5.14062 11.9999 5.14062C4.58452 5.14062 2.3999 12.1168 2.3999 12.1168C2.3999 12.1168 4.67683 18.7336 11.9999 18.8534Z"
      stroke={stroke}
      strokeWidth="1.5"
      fill={fill}
    />
    <path
      d="M14.4001 12.0307C14.4001 13.3205 13.3256 14.366 12.0001 14.366C10.6746 14.366 9.6001 13.3205 9.6001 12.0307C9.6001 10.7409 10.6746 9.69531 12.0001 9.69531C13.3256 9.69531 14.4001 10.7409 14.4001 12.0307Z"
      stroke={stroke}
      strokeWidth="1.5"
      fill="none"
    />
  </svg>
);

export const IconCloseEye = ({
  height = 24,
  width = 24,
  stroke = "#868686",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 18 19"
    fill="none"
  >
    <path
      d="M15.3008 15.0781L4.05078 3.82812M7.65078 8.2843C7.37072 8.59307 7.20078 8.99865 7.20078 9.44286C7.20078 10.4102 8.00667 11.1944 9.00078 11.1944C9.45914 11.1944 9.87748 11.0277 10.1953 10.7532M15.3299 11.1944C15.9495 10.2667 16.2008 9.51022 16.2008 9.51022C16.2008 9.51022 14.5623 4.27812 9.00078 4.27812C8.68855 4.27812 8.38869 4.29462 8.10078 4.32575M13.0508 13.4652C12.0177 14.1242 10.6878 14.5903 9.00078 14.5627C3.50847 14.4729 1.80078 9.51022 1.80078 9.51022C1.80078 9.51022 2.59417 6.97668 4.95078 5.43561"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const IconCart = ({ height = 24, width = 24, stroke = "#444444" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M2.3999 2.24219C1.98569 2.24219 1.6499 2.57797 1.6499 2.99219C1.6499 3.4064 1.98569 3.74219 2.3999 3.74219V2.24219ZM4.69244 2.99219L5.41636 2.79613C5.32782 2.4692 5.03114 2.24219 4.69244 2.24219V2.99219ZM8.41781 16.7474L7.69389 16.9435C7.79159 17.3042 8.13998 17.538 8.51084 17.4916L8.41781 16.7474ZM19.8805 15.3146L19.9735 16.0588C20.292 16.019 20.5499 15.7809 20.6149 15.4665L19.8805 15.3146ZM21.5999 7.00413L22.3343 7.15608C22.38 6.9352 22.3239 6.70547 22.1815 6.53056C22.0391 6.35565 21.8255 6.25413 21.5999 6.25413V7.00413ZM5.77901 7.00413L5.05509 7.20019L5.77901 7.00413ZM2.3999 3.74219H4.69244V2.24219H2.3999V3.74219ZM8.51084 17.4916L19.9735 16.0588L19.7875 14.5704L8.32479 16.0032L8.51084 17.4916ZM20.6149 15.4665L22.3343 7.15608L20.8655 6.85217L19.146 15.1626L20.6149 15.4665ZM3.96852 3.18825L5.05509 7.20019L6.50293 6.80807L5.41636 2.79613L3.96852 3.18825ZM5.05509 7.20019L7.69389 16.9435L9.14173 16.5514L6.50293 6.80807L5.05509 7.20019ZM21.5999 6.25413H5.77901V7.75413H21.5999V6.25413ZM11.2499 20.4995C11.2499 20.9137 10.9141 21.2495 10.4999 21.2495V22.7495C11.7425 22.7495 12.7499 21.7421 12.7499 20.4995H11.2499ZM10.4999 21.2495C10.0857 21.2495 9.7499 20.9137 9.7499 20.4995H8.2499C8.2499 21.7421 9.25726 22.7495 10.4999 22.7495V21.2495ZM9.7499 20.4995C9.7499 20.0852 10.0857 19.7495 10.4999 19.7495V18.2495C9.25726 18.2495 8.2499 19.2568 8.2499 20.4995H9.7499ZM10.4999 19.7495C10.9141 19.7495 11.2499 20.0852 11.2499 20.4995H12.7499C12.7499 19.2568 11.7425 18.2495 10.4999 18.2495V19.7495ZM19.2499 20.4995C19.2499 20.9137 18.9141 21.2495 18.4999 21.2495V22.7495C19.7425 22.7495 20.7499 21.7421 20.7499 20.4995H19.2499ZM18.4999 21.2495C18.0857 21.2495 17.7499 20.9137 17.7499 20.4995H16.2499C16.2499 21.7421 17.2573 22.7495 18.4999 22.7495V21.2495ZM17.7499 20.4995C17.7499 20.0852 18.0857 19.7495 18.4999 19.7495V18.2495C17.2573 18.2495 16.2499 19.2568 16.2499 20.4995H17.7499ZM18.4999 19.7495C18.9141 19.7495 19.2499 20.0852 19.2499 20.4995H20.7499C20.7499 19.2568 19.7425 18.2495 18.4999 18.2495V19.7495Z"
      fill={stroke}
    />
  </svg>
);

export const IconPlus = ({ height = 24, width = 24, stroke = "#fff" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12.0002 7.20312L12.0002 16.8031M16.8002 12.0031L7.2002 12.0031"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const IconTrash = ({ height = 24, width = 24, stroke = "#000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M4 6.17647H20M10 16.7647V10.4118M14 16.7647V10.4118M16 21H8C6.89543 21 6 20.0519 6 18.8824V7.23529C6 6.65052 6.44772 6.17647 7 6.17647H17C17.5523 6.17647 18 6.65052 18 7.23529V18.8824C18 20.0519 17.1046 21 16 21ZM10 6.17647H14C14.5523 6.17647 15 5.70242 15 5.11765V4.05882C15 3.47405 14.5523 3 14 3H10C9.44772 3 9 3.47405 9 4.05882V5.11765C9 5.70242 9.44772 6.17647 10 6.17647Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconCross = ({ height = 24, width = 24, stroke = "#444444" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M18 6L6 18M18 18L6 6"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const IconPreview = ({ height = 24, width = 24, stroke = "#444" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 25"
    fill="none"
  >
    <path
      d="M10.875 3.5H6.375C4.51104 3.5 3 5.01103 3 6.87498V18.125C3 19.989 4.51104 21.5 6.375 21.5H17.625C19.489 21.5 21 19.989 21 18.125V13.6249M15.3744 3.50027L21 3.5M21 3.5V8.56261M21 3.5L11.4367 13.0622"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconProduct = ({
  height = 32,
  width = 32,
  stroke = "#AB854A",
  customStyles = {},
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    style={customStyles}
  >
    <path
      d="M27.1034 9.60312L16.0182 3.20312L4.93311 9.60312V22.4031L16.0182 28.8031M27.1034 9.60312L16.0182 16.8031M27.1034 9.60312V22.0026L16.0182 28.8031M16.0182 28.8031V16.8031M16.0182 16.8031L5.61823 10.4031M20.8182 12.8031L10.4182 6.40312"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconSearch = ({ width = 18, height = 18, stroke = "#868686" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M12.6953 12.7831L15.3002 15.3031M14.4602 8.58312C14.4602 11.8306 11.8276 14.4631 8.5802 14.4631C5.33276 14.4631 2.7002 11.8306 2.7002 8.58312C2.7002 5.33569 5.33276 2.70312 8.5802 2.70312C11.8276 2.70312 14.4602 5.33569 14.4602 8.58312Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const IconGeo = ({ width = 22, height = 22, stroke = "#B0B0B0" }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <circle cx="10" cy="10" r="7" stroke={stroke} strokeWidth="1.5" />
    <path d="M3 10h14" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" />
    <path
      d="M10 3c2.4 1.9 3.8 4.4 3.8 7s-1.4 5.1-3.8 7"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M10 3c-2.4 1.9-3.8 4.4-3.8 7s1.4 5.1 3.8 7"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <circle cx="16.5" cy="16.5" r="3" stroke={stroke} strokeWidth="1.5" fill="none" />
    <path
      d="M18.7 18.7L21 21"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);


export const IconDownload = ({
  width = 16,
  height = 16,
  stroke = "#B0B0B0",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M4 20.3827C4.40471 20.778 4.95361 21 5.52595 21H18.4741C19.0464 21 19.5953 20.778 20 20.3827M12.0012 3V14.9425M12.0012 14.9425L16.9338 10.3793M12.0012 14.9425L7.06859 10.3793"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconPerson = ({ width = 18, height = 18, stroke = "#AB854A" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M3.19922 27.353C3.19922 22.319 7.40493 18.238 15.9992 18.238C24.5935 18.238 28.7992 22.319 28.7992 27.353C28.7992 28.1539 28.2149 28.8031 27.4941 28.8031H4.50432C3.78353 28.8031 3.19922 28.1539 3.19922 27.353Z"
      stroke={stroke}
      strokeWidth="1.5"
    />
    <path
      d="M20.7992 8.00312C20.7992 10.6541 18.6502 12.8031 15.9992 12.8031C13.3483 12.8031 11.1992 10.6541 11.1992 8.00312C11.1992 5.35216 13.3483 3.20312 15.9992 3.20312C18.6502 3.20312 20.7992 5.35216 20.7992 8.00312Z"
      stroke={stroke}
      strokeWidth="1.5"
    />
  </svg>
);

export const IconCheck = ({ width = 18, height = 18, stroke = "#AB854A" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    style={{ minWidth: width, minHeight: height }}
  >
    <path
      d="M14 7L8.03374 13L6 10.9548"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconUser = ({
  width = 18,
  height = 18,
  stroke = "#AB854A",
  strokeWidth = 2,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fill=""
      d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconSales = ({
  width = 18,
  height = 18,
  stroke = "currentColor",
  strokeWidth = 2,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 21H21"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="5"
      y="13"
      width="3"
      height="8"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="10.5"
      y="9"
      width="3"
      height="12"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="16"
      y="5"
      width="3"
      height="16"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 11L10 8L17 4M14 4H17V7"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconMail = ({
  width = 18,
  height = 18,
  stroke = "currentColor",
  strokeWidth = 2,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <polyline
      points="22,6 12,13 2,6"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconReport = ({
  width = 18,
  height = 18,
  stroke = "currentColor",
  strokeWidth = 2,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <polyline
      points="14 2 14 8 20 8"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="16"
      y1="13"
      x2="8"
      y2="13"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line
      x1="16"
      y1="17"
      x2="8"
      y2="17"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconFeedbackForm = ({
  width = 18,
  height = 18,
  stroke = "currentColor",
  strokeWidth = 1.6,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke={stroke}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M15 2.5H9.5A1.5 1.5 0 0 0 8 4v16a1.5 1.5 0 0 0 1.5 1.5h9A1.5 1.5 0 0 0 20 20V7.5z" />
    <polyline points="15 2.5 15 7.5 20 7.5" />
    <rect x="10.25" y="9.75" width="3" height="3" rx="0.5" />
    <polyline points="10.9 11.25 11.6 11.95 12.7 10.6" />
    <line x1="15" y1="11.25" x2="17.75" y2="11.25" />
    <rect x="10.25" y="15.25" width="3" height="3" rx="0.5" />
    <polyline points="10.9 16.75 11.6 17.45 12.7 16.1" />
    <line x1="15" y1="16.75" x2="17.75" y2="16.75" />
    <path d="M3 21.5l.9-2.7 5-5 1.8 1.8-5 5z" />
  </svg>
);

export const IconPdf = ({
  width = 14,
  height = 14,
  stroke = "currentColor",
  strokeWidth = 1.6,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <polyline
      points="14 2 14 8 20 8"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <text
      x="12"
      y="17.5"
      fontFamily="Helvetica, Arial, sans-serif"
      fontWeight="700"
      fontSize="5.6"
      textAnchor="middle"
      fill={stroke}
      stroke="none"
    >
      PDF
    </text>
  </svg>
);

export const IconCopy = ({
  width = 14,
  height = 14,
  stroke = "currentColor",
  strokeWidth = 2,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="9"
      y="9"
      width="13"
      height="13"
      rx="2"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconPhone = ({
  width = 16,
  height = 16,
  stroke = "currentColor",
  strokeWidth = 1.9,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconPin = ({
  width = 16,
  height = 16,
  stroke = "currentColor",
  strokeWidth = 1.9,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="10" r="3" stroke={stroke} strokeWidth={strokeWidth} />
  </svg>
);

export const IconContact = ({
  width = 16,
  height = 16,
  stroke = "currentColor",
  strokeWidth = 1.9,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16 2v4M8 2v4" stroke={stroke} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
    <rect x="3" y="4" width="18" height="18" rx="2" stroke={stroke} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="12" cy="11" r="2.5" stroke={stroke} strokeWidth={strokeWidth} />
    <path d="M8.5 17a3.5 3.5 0 0 1 7 0" stroke={stroke} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const IconCC = ({ width = 18, height = 18, stroke = "#AB854A" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1067_32622)">
      <path
        d="M7.38477 10.7804H9.02539V9.40625H13.1789V18.7496H11.7572V20.3902H16.2412V18.7496H14.8195V9.40625H18.973V10.7804H20.6137V7.76562H7.38477V10.7804Z"
        fill="#AB854A"
      />
      <path
        d="M26.0449 21.93V6.07004C27.191 5.59727 28 4.46841 28 3.15366C28 1.41471 26.5853 0 24.8463 0C23.5316 0 22.4027 0.808992 21.93 1.95508H6.07004C5.59727 0.808992 4.46841 0 3.15366 0C1.41471 0 0 1.41471 0 3.15366C0 4.46841 0.808992 5.59732 1.95508 6.07009V21.93C0.808992 22.4027 0 23.5316 0 24.8463C0 26.5853 1.41471 28 3.15366 28C4.46841 28 5.59727 27.191 6.07004 26.0449H21.93C22.4027 27.191 23.5316 28 24.8463 28C26.5853 28 28 26.5853 28 24.8463C28 23.5316 27.191 22.4027 26.0449 21.93ZM21.7243 24.4043H6.27566C6.08032 23.0185 4.98143 21.9196 3.5957 21.7243V6.27566C4.98143 6.08037 6.08032 4.98143 6.27566 3.5957H21.7243C21.9197 4.98148 23.0186 6.08037 24.4043 6.27566V21.7243C23.0186 21.9196 21.9197 23.0185 21.7243 24.4043ZM24.8463 1.64062C25.6806 1.64062 26.3594 2.31935 26.3594 3.15366C26.3594 3.98798 25.6806 4.6667 24.8463 4.6667C24.0121 4.6667 23.3334 3.98798 23.3334 3.15366C23.3334 2.31935 24.0121 1.64062 24.8463 1.64062ZM3.15366 1.64062C3.98792 1.64062 4.66665 2.31935 4.66665 3.15366C4.66665 3.98798 3.98792 4.6667 3.15366 4.6667C2.31935 4.66665 1.64062 3.98792 1.64062 3.15366C1.64062 2.31935 2.31935 1.64062 3.15366 1.64062ZM3.15366 26.3594C2.31935 26.3594 1.64062 25.6806 1.64062 24.8463C1.64062 24.012 2.31935 23.3333 3.15366 23.3333C3.98792 23.3333 4.66665 24.012 4.66665 24.8463C4.66665 25.6806 3.98792 26.3594 3.15366 26.3594ZM24.8463 26.3594C24.0121 26.3594 23.3334 25.6806 23.3334 24.8463C23.3334 24.012 24.0121 23.3333 24.8463 23.3333C25.6806 23.3333 26.3594 24.012 26.3594 24.8463C26.3594 25.6806 25.6806 26.3594 24.8463 26.3594Z"
        fill="#AB854A"
      />
    </g>
    <defs>
      <clipPath id="clip0_1067_32622">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const IconImage = ({ width = 18, height = 18, stroke = "#AB854A" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1067_32691)">
      <path
        d="M24.4221 0H3.57793C1.60502 0 0 1.60508 0 3.57798V24.4221C0 26.3949 1.60502 28 3.57793 28H24.4221C26.395 28 28 26.3949 28 24.422V3.57798C28 1.60508 26.395 0 24.4221 0ZM26.3507 24.4221C26.3507 25.4856 25.4855 26.3507 24.4221 26.3507H3.57793C2.51442 26.3507 1.64921 25.4855 1.64921 24.4221V21.4139L7.07722 16.7955C7.2753 16.6269 7.56427 16.6253 7.7642 16.7914L11.1643 19.6148C11.4922 19.8869 11.9734 19.8646 12.2747 19.563L20.3536 11.4718C20.4997 11.3255 20.6699 11.3113 20.7588 11.3158C20.8474 11.3204 21.0155 11.352 21.1459 11.5125L26.3508 17.9213L26.3507 24.4221ZM26.3507 15.3051L22.426 10.4726C22.0368 9.99332 21.4599 9.7003 20.8433 9.66864C20.227 9.63747 19.6228 9.86945 19.1866 10.3064L11.6392 17.8654L8.81792 15.5226C7.99985 14.8433 6.81838 14.8503 6.00846 15.5395L1.64921 19.2485V3.57798C1.64921 2.51448 2.51442 1.64927 3.57793 1.64927H24.4221C25.4856 1.64927 26.3507 2.51448 26.3507 3.57798V15.3051Z"
        fill="#AB854A"
      />
      <path
        d="M8.81438 3.44531C6.62169 3.44531 4.83789 5.22922 4.83789 7.4218C4.83789 9.61445 6.62174 11.3983 8.81438 11.3983C11.007 11.3983 12.7909 9.61445 12.7909 7.4218C12.7909 5.22916 11.0071 3.44531 8.81438 3.44531ZM8.81438 9.74909C7.53109 9.74909 6.4871 8.70505 6.4871 7.4218C6.4871 6.13851 7.53109 5.09452 8.81438 5.09452C10.0977 5.09452 11.1417 6.13856 11.1417 7.4218C11.1417 8.70505 10.0977 9.74909 8.81438 9.74909Z"
        fill="#AB854A"
      />
    </g>
    <defs>
      <clipPath id="clip0_1067_32691">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const IconPlayBox = ({ size = 24, stroke = "white" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M15.5998 12.8079L15.1906 12.1793L15.1802 12.1861L15.17 12.1933L15.5998 12.8079ZM15.5998 11.4317L15.1551 12.0356L15.1886 12.0603L15.2246 12.081L15.5998 11.4317ZM10.0844 7.3704L10.5291 6.76647L10.508 6.75089L10.4858 6.73682L10.0844 7.3704ZM8.92814 7.97701L9.67826 7.97483L9.67799 7.9617L8.92814 7.97701ZM8.95127 15.9547L8.20127 15.9569L8.20133 15.9781L8.20259 15.9993L8.95127 15.9547ZM10.1499 16.6195L10.5131 17.2757L10.5475 17.2567L10.5798 17.2341L10.1499 16.6195ZM6.00039 3.14844H18.0004V1.64844H6.00039V3.14844ZM20.8504 5.99844V17.9984H22.3504V5.99844H20.8504ZM18.0004 20.8484H6.00039V22.3484H18.0004V20.8484ZM3.15039 17.9984V5.99844H1.65039V17.9984H3.15039ZM6.00039 20.8484C4.42638 20.8484 3.15039 19.5724 3.15039 17.9984H1.65039C1.65039 20.4009 3.59795 22.3484 6.00039 22.3484V20.8484ZM20.8504 17.9984C20.8504 19.5724 19.5744 20.8484 18.0004 20.8484V22.3484C20.4028 22.3484 22.3504 20.4009 22.3504 17.9984H20.8504ZM18.0004 3.14844C19.5744 3.14844 20.8504 4.42443 20.8504 5.99844H22.3504C22.3504 3.596 20.4028 1.64844 18.0004 1.64844V3.14844ZM6.00039 1.64844C3.59795 1.64844 1.65039 3.596 1.65039 5.99844H3.15039C3.15039 4.42443 4.42638 3.14844 6.00039 3.14844V1.64844ZM16.009 13.4364C16.423 13.1669 16.8787 12.728 16.8779 12.0989C16.877 11.4529 16.4 11.0279 15.9751 10.7823L15.2246 12.081C15.2836 12.1152 15.3265 12.1454 15.3568 12.17C15.3871 12.1948 15.4012 12.211 15.4055 12.2165C15.4095 12.2217 15.4022 12.2138 15.3939 12.1919C15.3851 12.1688 15.3779 12.1373 15.3779 12.1009C15.3778 12.0648 15.3848 12.0362 15.3914 12.0183C15.3975 12.0016 15.4015 11.999 15.3934 12.01C15.3852 12.0211 15.367 12.0427 15.3329 12.073C15.299 12.1031 15.2526 12.139 15.1906 12.1793L16.009 13.4364ZM16.0445 10.8278L10.5291 6.76647L9.63971 7.97434L15.1551 12.0356L16.0445 10.8278ZM10.4858 6.73682C10.0613 6.46797 9.49245 6.33057 8.9688 6.57507C8.40373 6.83891 8.16647 7.41262 8.1783 7.99231L9.67799 7.9617C9.67613 7.87057 9.69392 7.84603 9.68661 7.86002C9.6828 7.86731 9.67403 7.88112 9.65806 7.89658C9.642 7.91212 9.62307 7.92503 9.60341 7.93422C9.56304 7.95307 9.54156 7.94686 9.55629 7.94892C9.56365 7.94995 9.57859 7.953 9.60067 7.9615C9.62268 7.96997 9.65054 7.98338 9.68307 8.00398L10.4858 6.73682ZM8.17815 7.97918L8.20127 15.9569L9.70127 15.9525L9.67814 7.97483L8.17815 7.97918ZM8.20259 15.9993C8.23255 16.5025 8.40398 17.102 8.9588 17.3983C9.50586 17.6905 10.0932 17.5081 10.5131 17.2757L9.78677 15.9633C9.73009 15.9947 9.68351 16.0154 9.64706 16.0287C9.61046 16.0421 9.58766 16.0466 9.57762 16.0479C9.56789 16.0493 9.57368 16.0473 9.59139 16.0499C9.61016 16.0526 9.63664 16.0598 9.66545 16.0752C9.69436 16.0906 9.71595 16.1092 9.72991 16.1247C9.74314 16.1395 9.74547 16.147 9.74185 16.1393C9.73805 16.1312 9.7294 16.1099 9.72067 16.0708C9.71197 16.0318 9.70404 15.979 9.69994 15.9101L8.20259 15.9993ZM10.5798 17.2341L16.0297 13.4225L15.17 12.1933L9.72009 16.0049L10.5798 17.2341Z"
      fill={stroke}
    />
  </svg>
);

export const IconInstagram = ({ size = 16, stroke = "white" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_134_13377)">
      <path
        d="M8.00279 3.89062C5.73413 3.89062 3.89746 5.72929 3.89746 7.99596C3.89746 10.2646 5.73613 12.1013 8.00279 12.1013C10.2715 12.1013 12.1081 10.2626 12.1081 7.99596C12.1081 5.72729 10.2695 3.89062 8.00279 3.89062ZM8.00279 10.6606C6.53013 10.6606 5.33813 9.46796 5.33813 7.99596C5.33813 6.52396 6.53079 5.33129 8.00279 5.33129C9.47479 5.33129 10.6675 6.52396 10.6675 7.99596C10.6681 9.46796 9.47546 10.6606 8.00279 10.6606Z"
        fill={stroke}
      />
      <path
        d="M11.2988 0.0502578C9.82682 -0.0184089 6.18082 -0.0150756 4.70749 0.0502578C3.41282 0.110924 2.27082 0.423591 1.35015 1.34426C-0.188515 2.88292 0.00815151 4.95626 0.00815151 7.99692C0.00815151 11.1089 -0.165182 13.1343 1.35015 14.6496C2.89482 16.1936 4.99815 15.9916 8.00282 15.9916C11.0855 15.9916 12.1495 15.9936 13.2395 15.5716C14.7215 14.9963 15.8402 13.6716 15.9495 11.2923C16.0188 9.81959 16.0148 6.17426 15.9495 4.70092C15.8175 1.89226 14.3102 0.188924 11.2988 0.0502578ZM13.6288 13.6316C12.6202 14.6403 11.2208 14.5503 7.98349 14.5503C4.65015 14.5503 3.31348 14.5996 2.33815 13.6216C1.21482 12.5036 1.41815 10.7083 1.41815 7.98626C1.41815 4.30292 1.04015 1.65026 4.73682 1.46092C5.58615 1.43092 5.83615 1.42092 7.97415 1.42092L8.00415 1.44092C11.5568 1.44092 14.3442 1.06892 14.5115 4.76492C14.5495 5.60826 14.5582 5.86159 14.5582 7.99626C14.5575 11.2909 14.6202 12.6356 13.6288 13.6316Z"
        fill={stroke}
      />
      <path
        d="M12.2709 4.6921C12.8007 4.6921 13.2302 4.2626 13.2302 3.73277C13.2302 3.20295 12.8007 2.77344 12.2709 2.77344C11.741 2.77344 11.3115 3.20295 11.3115 3.73277C11.3115 4.2626 11.741 4.6921 12.2709 4.6921Z"
        fill={stroke}
      />
    </g>
    <defs>
      <clipPath id="clip0_134_13377">
        <rect width="16" height="16" fill={stroke} />
      </clipPath>
    </defs>
  </svg>
);

export const IconLinkedin = ({ size = 16, stroke = "white" }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_134_13399)">
      <path
        d="M15.9968 16.0054L16.0008 16.0047V10.1367C16.0008 7.26602 15.3828 5.05469 12.0268 5.05469C10.4135 5.05469 9.33082 5.94002 8.88882 6.77935H8.84216V5.32269H5.66016V16.0047H8.97349V10.7154C8.97349 9.32269 9.23749 7.97602 10.9622 7.97602C12.6615 7.97602 12.6868 9.56535 12.6868 10.8047V16.0054H15.9968Z"
        fill={stroke}
      />
      <path
        d="M0.264648 5.32031H3.58198V16.0023H0.264648V5.32031Z"
        fill={stroke}
      />
      <path
        d="M1.92133 0C0.860667 0 0 0.860667 0 1.92133C0 2.982 0.860667 3.86067 1.92133 3.86067C2.982 3.86067 3.84267 2.982 3.84267 1.92133C3.842 0.860667 2.98133 0 1.92133 0Z"
        fill={stroke}
      />
    </g>
    <defs>
      <clipPath id="clip0_134_13399">
        <rect width="16" height="16" fill={stroke} />
      </clipPath>
    </defs>
  </svg>
);

export const IconFacebook = ({ size = 16, stroke = "white" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M10.665 2.65667H12.1257V0.112667C11.8737 0.078 11.007 0 9.99767 0C7.89167 0 6.449 1.32467 6.449 3.75933V6H4.125V8.844H6.449V16H9.29833V8.84467H11.5283L11.8823 6.00067H9.29767V4.04133C9.29833 3.21933 9.51967 2.65667 10.665 2.65667Z"
      fill={stroke}
    />
  </svg>
);

export const IconExpert = ({ width = 24, height = 24, stroke = "#B0B0B0" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M11.7144 8.99989C11.7144 10.5113 10.6592 11.5854 9.35753 11.5854C8.05585 11.5854 7.00063 10.5113 7.00063 8.99989C7.00063 7.48848 8.05585 6.58535 9.35753 6.58535C10.6592 6.58535 11.7144 7.48848 11.7144 8.99989Z"
      fill={stroke}
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M15.5 17.6851C15.5 19.2397 13.6818 20.4999 9.5 20.4999C5.31818 20.4999 3.5 19.2397 3.5 17.6851C3.5 16.1305 6.18629 14.8702 9.5 14.8702C12.8137 14.8702 15.5 16.1305 15.5 17.6851Z"
      fill={stroke}
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M17 4L17.8499 5.83016L19.8532 6.07295L18.3752 7.44684L18.7634 9.42705L17 8.446L15.2366 9.42705L15.6248 7.44684L14.1468 6.07295L16.1501 5.83016L17 4Z"
      fill={stroke}
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

export const ThinIconStory = ({ size = 64, stroke = "#B0B0B0" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
  >
    <path
      d="M16.1666 12.5859C15.7524 12.5859 15.4166 12.9217 15.4166 13.3359C15.4166 13.7502 15.7524 14.0859 16.1666 14.0859V12.5859ZM47.8333 14.0859C48.2475 14.0859 48.5833 13.7502 48.5833 13.3359C48.5833 12.9217 48.2475 12.5859 47.8333 12.5859V14.0859ZM21.3333 4.58594C20.9191 4.58594 20.5833 4.92172 20.5833 5.33594C20.5833 5.75015 20.9191 6.08594 21.3333 6.08594V4.58594ZM42.6666 6.08594C43.0808 6.08594 43.4166 5.75015 43.4166 5.33594C43.4166 4.92172 43.0808 4.58594 42.6666 4.58594V6.08594ZM39.0221 41.3517L38.643 40.7045L38.6327 40.7106L38.6226 40.7169L39.0221 41.3517ZM39.0221 39.058L38.6078 39.6832L38.6409 39.7051L38.676 39.7234L39.0221 39.058ZM28.8084 32.2892L29.2227 31.664L29.2017 31.6501L29.1799 31.6377L28.8084 32.2892ZM26.6672 33.3002L27.4172 33.2978L27.4171 33.2905L27.417 33.2832L26.6672 33.3002ZM26.71 46.5964L25.96 46.5988L25.9601 46.6224L25.9616 46.6459L26.71 46.5964ZM28.9297 47.7044L29.2641 48.3758L29.2976 48.3591L29.3293 48.3391L28.9297 47.7044ZM16.1666 22.0859H47.8333V20.5859H16.1666V22.0859ZM56.5833 28.3359V51.6693H58.0833V28.3359H56.5833ZM47.8333 57.9193H16.1666V59.4193H47.8333V57.9193ZM7.41663 51.6693V28.3359H5.91663V51.6693H7.41663ZM16.1666 57.9193C13.6868 57.9193 11.4715 57.1776 9.89401 56.0152C8.31619 54.8526 7.41663 53.3075 7.41663 51.6693H5.91663C5.91663 53.897 7.14371 55.8519 9.00421 57.2228C10.865 58.5939 13.3998 59.4193 16.1666 59.4193V57.9193ZM56.5833 51.6693C56.5833 53.3075 55.6837 54.8526 54.1059 56.0152C52.5284 57.1776 50.3131 57.9193 47.8333 57.9193V59.4193C50.6002 59.4193 53.1349 58.5939 54.9957 57.2228C56.8562 55.8519 58.0833 53.897 58.0833 51.6693H56.5833ZM47.8333 22.0859C50.3131 22.0859 52.5284 22.8276 54.1059 23.99C55.6837 25.1526 56.5833 26.6977 56.5833 28.3359H58.0833C58.0833 26.1082 56.8562 24.1533 54.9957 22.7824C53.1349 21.4113 50.6002 20.5859 47.8333 20.5859V22.0859ZM16.1666 20.5859C13.3998 20.5859 10.865 21.4113 9.00421 22.7824C7.14371 24.1533 5.91663 26.1082 5.91663 28.3359H7.41663C7.41663 26.6977 8.31619 25.1526 9.89401 23.99C11.4715 22.8276 13.6868 22.0859 16.1666 22.0859V20.5859ZM16.1666 14.0859H47.8333V12.5859H16.1666V14.0859ZM21.3333 6.08594H42.6666V4.58594H21.3333V6.08594ZM39.4013 41.9988C40.0927 41.5937 40.7512 40.9955 40.75 40.1706C40.7487 39.3274 40.0655 38.7553 39.3682 38.3926L38.676 39.7234C38.9515 39.8667 39.1088 39.9947 39.1896 40.0873C39.2646 40.1733 39.25 40.1991 39.25 40.1728C39.2499 40.15 39.2617 40.1861 39.177 40.2891C39.0887 40.3964 38.9234 40.5402 38.643 40.7045L39.4013 41.9988ZM39.4364 38.4328L29.2227 31.664L28.3941 32.9144L38.6078 39.6832L39.4364 38.4328ZM29.1799 31.6377C28.5154 31.2589 27.7236 31.1174 27.0395 31.4049C26.2962 31.7172 25.8975 32.4411 25.9174 33.3172L27.417 33.2832C27.4123 33.079 27.4547 32.9627 27.4894 32.9029C27.5217 32.8473 27.5632 32.8119 27.6206 32.7877C27.7496 32.7335 28.0427 32.716 28.4369 32.9408L29.1799 31.6377ZM25.9172 33.3026L25.96 46.5988L27.46 46.594L27.4172 33.2978L25.9172 33.3026ZM25.9616 46.6459C26.0152 47.4551 26.3174 48.222 27.0533 48.5757C27.7503 48.9108 28.5532 48.7299 29.2641 48.3758L28.5954 47.0331C28.0382 47.3106 27.7764 47.259 27.7031 47.2238C27.6688 47.2073 27.4952 47.1044 27.4584 46.5469L25.9616 46.6459ZM29.3293 48.3391L39.4217 41.9864L38.6226 40.7169L28.5302 47.0697L29.3293 48.3391Z"
      fill={stroke}
    />
  </svg>
);
export const IconStory = ({ width = 24, height = 24, stroke = "#B0B0B0" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M6.0625 4.25C5.64829 4.25 5.3125 4.58579 5.3125 5C5.3125 5.41421 5.64829 5.75 6.0625 5.75V4.25ZM17.9375 5.75C18.3517 5.75 18.6875 5.41421 18.6875 5C18.6875 4.58579 18.3517 4.25 17.9375 4.25V5.75ZM8 1.25C7.58579 1.25 7.25 1.58579 7.25 2C7.25 2.41421 7.58579 2.75 8 2.75V1.25ZM16 2.75C16.4142 2.75 16.75 2.41421 16.75 2C16.75 1.58579 16.4142 1.25 16 1.25V2.75ZM14.6333 15.5059L14.2542 14.8588L14.2439 14.8648L14.2338 14.8712L14.6333 15.5059ZM14.6333 14.6458L14.219 15.271L14.2521 15.2929L14.2872 15.3112L14.6333 14.6458ZM10.8032 12.1075L11.2175 11.4823L11.1965 11.4684L11.1746 11.4559L10.8032 12.1075ZM10.0002 12.4866L10.7502 12.4842L10.7502 12.4769L10.75 12.4696L10.0002 12.4866ZM10.0163 17.4727L9.26627 17.4751L9.26634 17.4987L9.2679 17.5222L10.0163 17.4727ZM10.8487 17.8882L11.183 18.5595L11.2165 18.5428L11.2482 18.5229L10.8487 17.8882ZM6.0625 8.75H17.9375V7.25H6.0625V8.75ZM20.75 10.625V19.375H22.25V10.625H20.75ZM17.9375 21.25H6.0625V22.75H17.9375V21.25ZM3.25 19.375V10.625H1.75V19.375H3.25ZM6.0625 21.25C5.22226 21.25 4.49138 20.998 3.98833 20.6274C3.48499 20.2565 3.25 19.8051 3.25 19.375H1.75C1.75 20.3946 2.3125 21.2558 3.09853 21.8349C3.88485 22.4143 4.93522 22.75 6.0625 22.75V21.25ZM20.75 19.375C20.75 19.8051 20.515 20.2565 20.0117 20.6274C19.5086 20.998 18.7777 21.25 17.9375 21.25V22.75C19.0648 22.75 20.1151 22.4143 20.9015 21.8349C21.6875 21.2558 22.25 20.3946 22.25 19.375H20.75ZM17.9375 8.75C18.7777 8.75 19.5086 9.00197 20.0117 9.37264C20.515 9.74352 20.75 10.1949 20.75 10.625H22.25C22.25 9.60536 21.6875 8.74423 20.9015 8.16505C20.1151 7.58566 19.0648 7.25 17.9375 7.25V8.75ZM6.0625 7.25C4.93522 7.25 3.88485 7.58566 3.09853 8.16505C2.3125 8.74423 1.75 9.60536 1.75 10.625H3.25C3.25 10.1949 3.48499 9.74352 3.98833 9.37264C4.49138 9.00197 5.22226 8.75 6.0625 8.75V7.25ZM6.0625 5.75H17.9375V4.25H6.0625V5.75ZM8 2.75H16V1.25H8V2.75ZM15.0124 16.153C15.2957 15.987 15.7509 15.6415 15.75 15.0623C15.7491 14.4648 15.27 14.1316 14.9794 13.9804L14.2872 15.3112C14.3594 15.3487 14.3639 15.3641 14.3428 15.3398C14.3159 15.309 14.2502 15.2136 14.25 15.0645C14.2498 14.9189 14.3123 14.8304 14.3294 14.8097C14.343 14.7931 14.3305 14.8141 14.2542 14.8588L15.0124 16.153ZM15.0476 14.0206L11.2175 11.4823L10.3889 12.7327L14.219 15.271L15.0476 14.0206ZM11.1746 11.4559C10.841 11.2657 10.3882 11.163 9.95823 11.3437C9.46898 11.5493 9.23945 12.0209 9.25039 12.5036L10.75 12.4696C10.7498 12.4621 10.7521 12.5072 10.7139 12.573C10.6733 12.643 10.6089 12.6973 10.5393 12.7266C10.4143 12.7791 10.3683 12.7229 10.4317 12.759L11.1746 11.4559ZM9.25021 12.489L9.26627 17.4751L10.7663 17.4703L10.7502 12.4842L9.25021 12.489ZM9.2679 17.5222C9.29317 17.9043 9.44674 18.3994 9.94194 18.6374C10.3983 18.8567 10.8684 18.7162 11.183 18.5595L10.5143 17.2168C10.4481 17.2498 10.4213 17.2521 10.4299 17.251C10.4416 17.2496 10.5067 17.2446 10.5918 17.2855C10.6824 17.329 10.7356 17.3958 10.7588 17.4404C10.7776 17.4765 10.7684 17.4804 10.7646 17.4232L9.2679 17.5222ZM11.2482 18.5229L15.0328 16.1406L14.2338 14.8712L10.4491 17.2535L11.2482 18.5229Z"
      fill={stroke}
    />
  </svg>
);

export const IconRemoveStory = ({ size = 24, stroke = "#B0B0B0" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M6.0625 5H17.9375M8 2H16M6.0625 22H17.9375C19.905 22 21.5 20.8247 21.5 19.375V10.625C21.5 9.17525 19.905 8 17.9375 8H6.0625C4.09499 8 2.5 9.17525 2.5 10.625V19.375C2.5 20.8247 4.09499 22 6.0625 22Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 15C12.6569 15 11.3431 15 9 15"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconRatio = ({ width = 24, height = 24, stroke = "#B0B0B0" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M10.0004 6.74844C10.4146 6.74844 10.7504 6.41265 10.7504 5.99844C10.7504 5.58422 10.4146 5.24844 10.0004 5.24844V6.74844ZM5.25039 9.99844C5.25039 10.4127 5.58618 10.7484 6.00039 10.7484C6.4146 10.7484 6.75039 10.4127 6.75039 9.99844H5.25039ZM18.7504 13.9984C18.7504 13.5842 18.4146 13.2484 18.0004 13.2484C17.5862 13.2484 17.2504 13.5842 17.2504 13.9984H18.7504ZM14.0004 17.2484C13.5862 17.2484 13.2504 17.5842 13.2504 17.9984C13.2504 18.4127 13.5862 18.7484 14.0004 18.7484V17.2484ZM6.00039 3.14844H18.0004V1.64844H6.00039V3.14844ZM20.8504 5.99844V17.9984H22.3504V5.99844H20.8504ZM18.0004 20.8484H6.00039V22.3484H18.0004V20.8484ZM3.15039 17.9984V5.99844H1.65039V17.9984H3.15039ZM6.00039 20.8484C4.42638 20.8484 3.15039 19.5724 3.15039 17.9984H1.65039C1.65039 20.4009 3.59795 22.3484 6.00039 22.3484V20.8484ZM20.8504 17.9984C20.8504 19.5724 19.5744 20.8484 18.0004 20.8484V22.3484C20.4028 22.3484 22.3504 20.4009 22.3504 17.9984H20.8504ZM18.0004 3.14844C19.5744 3.14844 20.8504 4.42443 20.8504 5.99844H22.3504C22.3504 3.596 20.4028 1.64844 18.0004 1.64844V3.14844ZM6.00039 1.64844C3.59795 1.64844 1.65039 3.596 1.65039 5.99844H3.15039C3.15039 4.42443 4.42638 3.14844 6.00039 3.14844V1.64844ZM7.33372 6.74844H10.0004V5.24844H7.33372V6.74844ZM6.75039 9.99844V7.33177H5.25039V9.99844H6.75039ZM7.33372 5.24844C6.18313 5.24844 5.25039 6.18118 5.25039 7.33177H6.75039C6.75039 7.0096 7.01156 6.74844 7.33372 6.74844V5.24844ZM17.2504 13.9984V16.6651H18.7504V13.9984H17.2504ZM16.6671 17.2484H14.0004V18.7484H16.6671V17.2484ZM17.2504 16.6651C17.2504 16.9873 16.9892 17.2484 16.6671 17.2484V18.7484C17.8176 18.7484 18.7504 17.8157 18.7504 16.6651H17.2504Z"
      fill={stroke}
    />
  </svg>
);

export const IconArrowDown = ({
  width = 24,
  height = 24,
  stroke = "#B0B0B0",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M4.66699 6.66406L8.00087 9.7174L11.3337 6.66406"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconArrowRight = ({
  width = 24,
  height = 24,
  stroke = "currentColor",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M4 12H19M19 12L13 6M19 12L13 18"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconArrowUp = ({
  width = 24,
  height = 24,
  stroke = "#B0B0B0",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M4.66699 9.71969L8.00087 6.66406L11.3337 9.71969"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconDot = ({ width = 18, height = 18, stroke = "#5E5E5E" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M9.0002 5.39688C8.00608 5.39688 7.2002 4.59099 7.2002 3.59687C7.2002 2.60276 8.00608 1.79687 9.0002 1.79688C9.99431 1.79688 10.8002 2.60276 10.8002 3.59688C10.8002 4.59099 9.99431 5.39688 9.0002 5.39688Z"
      fill={stroke}
    />
    <path
      d="M9.0002 10.7969C8.00608 10.7969 7.2002 9.99099 7.2002 8.99688C7.2002 8.00276 8.00608 7.19688 9.0002 7.19688C9.99431 7.19688 10.8002 8.00276 10.8002 8.99688C10.8002 9.99099 9.99431 10.7969 9.0002 10.7969Z"
      fill={stroke}
    />
    <path
      d="M9.0002 16.1969C8.00608 16.1969 7.2002 15.391 7.2002 14.3969C7.2002 13.4028 8.00608 12.5969 9.0002 12.5969C9.99431 12.5969 10.8002 13.4028 10.8002 14.3969C10.8002 15.391 9.99431 16.1969 9.0002 16.1969Z"
      fill={stroke}
    />
  </svg>
);

export const IconShare = ({ size = 24, stroke = "#B0B0B0", fill = "none" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="share">
      <path
        id="Icon"
        d="M21.0002 11.4606L11.4002 5.10156L11.4002 8.70156C3 10.5016 3 18.9016 3 18.9016C3 18.9016 6.6 14.1016 11.4002 14.7016L11.4002 18.4216L21.0002 11.4606Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const IconPencil = ({ size = 24, stroke = "#B0B0B0" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="edit-03">
      <path
        id="Icon"
        d="M13.7992 19.5485H19.7992M4.19922 19.5485L8.5652 18.6688C8.79698 18.6221 9.0098 18.508 9.17694 18.3407L18.9506 8.56168C19.4192 8.09283 19.4189 7.33284 18.9499 6.86438L16.8795 4.7963C16.4107 4.32804 15.6511 4.32836 15.1827 4.79702L5.40798 14.5771C5.24117 14.744 5.12727 14.9564 5.08052 15.1877L4.19922 19.5485Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const IconVideo = ({ size = 24, stroke = "#AB854A" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.00039 2.39844H18.0004C19.9886 2.39844 21.6004 4.01021 21.6004 5.99844V17.9984C21.6004 19.9867 19.9886 21.5984 18.0004 21.5984H6.00039C4.01217 21.5984 2.40039 19.9867 2.40039 17.9984V5.99844C2.40039 4.01021 4.01217 2.39844 6.00039 2.39844ZM15.5998 11.4317C16.3026 11.8378 16.3051 12.3487 15.5998 12.8079L10.1499 16.6195C9.46517 16.9985 9.00009 16.7747 8.95127 15.9547L8.92814 7.97701C8.91273 7.22166 9.5127 7.00825 10.0844 7.3704L15.5998 11.4317Z"
      fill={stroke}
    />
    <path
      d="M15.5998 12.8079L15.1906 12.1793L15.1802 12.1861L15.17 12.1933L15.5998 12.8079ZM15.5998 11.4317L15.1551 12.0356L15.1886 12.0603L15.2246 12.081L15.5998 11.4317ZM10.0844 7.3704L10.5291 6.76647L10.508 6.75089L10.4858 6.73682L10.0844 7.3704ZM8.92814 7.97701L9.67826 7.97483L9.67799 7.9617L8.92814 7.97701ZM8.95127 15.9547L8.20127 15.9569L8.20133 15.9781L8.20259 15.9993L8.95127 15.9547ZM10.1499 16.6195L10.5131 17.2757L10.5475 17.2567L10.5798 17.2341L10.1499 16.6195ZM6.00039 3.14844H18.0004V1.64844H6.00039V3.14844ZM20.8504 5.99844V17.9984H22.3504V5.99844H20.8504ZM18.0004 20.8484H6.00039V22.3484H18.0004V20.8484ZM3.15039 17.9984V5.99844H1.65039V17.9984H3.15039ZM6.00039 20.8484C4.42638 20.8484 3.15039 19.5724 3.15039 17.9984H1.65039C1.65039 20.4009 3.59795 22.3484 6.00039 22.3484V20.8484ZM20.8504 17.9984C20.8504 19.5724 19.5744 20.8484 18.0004 20.8484V22.3484C20.4028 22.3484 22.3504 20.4009 22.3504 17.9984H20.8504ZM18.0004 3.14844C19.5744 3.14844 20.8504 4.42443 20.8504 5.99844H22.3504C22.3504 3.596 20.4028 1.64844 18.0004 1.64844V3.14844ZM6.00039 1.64844C3.59795 1.64844 1.65039 3.596 1.65039 5.99844H3.15039C3.15039 4.42443 4.42638 3.14844 6.00039 3.14844V1.64844ZM16.009 13.4364C16.423 13.1669 16.8787 12.728 16.8779 12.0989C16.877 11.4529 16.4 11.0279 15.9751 10.7823L15.2246 12.081C15.2836 12.1152 15.3265 12.1454 15.3568 12.17C15.3871 12.1948 15.4012 12.211 15.4055 12.2165C15.4095 12.2217 15.4022 12.2138 15.3939 12.1919C15.3851 12.1688 15.3779 12.1373 15.3779 12.1009C15.3778 12.0648 15.3848 12.0362 15.3914 12.0183C15.3975 12.0016 15.4015 11.999 15.3934 12.01C15.3852 12.0211 15.367 12.0427 15.3329 12.073C15.299 12.1031 15.2526 12.139 15.1906 12.1793L16.009 13.4364ZM16.0445 10.8278L10.5291 6.76647L9.63971 7.97434L15.1551 12.0356L16.0445 10.8278ZM10.4858 6.73682C10.0613 6.46797 9.49245 6.33057 8.9688 6.57507C8.40373 6.83891 8.16647 7.41262 8.1783 7.99231L9.67799 7.9617C9.67613 7.87057 9.69392 7.84603 9.68661 7.86002C9.6828 7.86731 9.67403 7.88112 9.65806 7.89658C9.642 7.91212 9.62307 7.92503 9.60341 7.93422C9.56304 7.95307 9.54156 7.94686 9.55629 7.94892C9.56365 7.94995 9.57859 7.953 9.60067 7.9615C9.62268 7.96997 9.65054 7.98338 9.68307 8.00398L10.4858 6.73682ZM8.17815 7.97918L8.20127 15.9569L9.70127 15.9525L9.67814 7.97483L8.17815 7.97918ZM8.20259 15.9993C8.23255 16.5025 8.40398 17.102 8.9588 17.3983C9.50586 17.6905 10.0932 17.5081 10.5131 17.2757L9.78677 15.9633C9.73009 15.9947 9.68351 16.0154 9.64706 16.0287C9.61046 16.0421 9.58766 16.0466 9.57762 16.0479C9.56789 16.0493 9.57368 16.0473 9.59139 16.0499C9.61016 16.0526 9.63664 16.0598 9.66545 16.0752C9.69436 16.0906 9.71595 16.1092 9.72991 16.1247C9.74314 16.1395 9.74547 16.147 9.74185 16.1393C9.73805 16.1312 9.7294 16.1099 9.72067 16.0708C9.71197 16.0318 9.70404 15.979 9.69994 15.9101L8.20259 15.9993ZM10.5798 17.2341L16.0297 13.4225L15.17 12.1933L9.72009 16.0049L10.5798 17.2341Z"
      fill={stroke}
    />
  </svg>
);

export const IconHorizontalDot = ({ size = 24, stroke = "#444" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M7.20039 12.0016C7.20039 13.327 6.12587 14.4016 4.80039 14.4016C3.47491 14.4016 2.40039 13.327 2.40039 12.0016C2.40039 10.6761 3.47491 9.60156 4.80039 9.60156C6.12587 9.60156 7.20039 10.6761 7.20039 12.0016Z"
      fill={stroke}
    />
    <path
      d="M14.4004 12.0016C14.4004 13.327 13.3259 14.4016 12.0004 14.4016C10.6749 14.4016 9.60039 13.327 9.60039 12.0016C9.60039 10.6761 10.6749 9.60156 12.0004 9.60156C13.3259 9.60156 14.4004 10.6761 14.4004 12.0016Z"
      fill={stroke}
    />
    <path
      d="M21.6004 12.0016C21.6004 13.327 20.5259 14.4016 19.2004 14.4016C17.8749 14.4016 16.8004 13.327 16.8004 12.0016C16.8004 10.6761 17.8749 9.60156 19.2004 9.60156C20.5259 9.60156 21.6004 10.6761 21.6004 12.0016Z"
      fill={stroke}
    />
  </svg>
);

export const IconQr = ({ size = 20, stroke = "#B0B0B0", fill = "#B0B0B0" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_1458_37967)">
      <path
        d="M0.833008 6.46094C1.17806 6.46094 1.45801 6.18099 1.45801 5.83594V1.46094H5.83301C6.17806 1.46094 6.45801 1.18099 6.45801 0.835938C6.45801 0.490885 6.17806 0.210938 5.83301 0.210938H0.833008C0.487956 0.210938 0.208008 0.490885 0.208008 0.835938V5.83594C0.208008 6.18099 0.487956 6.46094 0.833008 6.46094Z"
        fill={stroke}
      />
      <path
        d="M19.166 0.210938H14.166C13.821 0.210938 13.541 0.490885 13.541 0.835938C13.541 1.18099 13.821 1.46094 14.166 1.46094H18.541V5.83594C18.541 6.18099 18.821 6.46094 19.166 6.46094C19.5111 6.46094 19.791 6.18099 19.791 5.83594V0.835938C19.791 0.490885 19.5111 0.210938 19.166 0.210938Z"
        fill={stroke}
      />
      <path
        d="M5.83301 18.5469H1.45801V14.1719C1.45801 13.8268 1.17806 13.5469 0.833008 13.5469C0.487956 13.5469 0.208008 13.8268 0.208008 14.1719V19.1719C0.208008 19.5169 0.487956 19.7969 0.833008 19.7969H5.83301C6.17806 19.7969 6.45801 19.5169 6.45801 19.1719C6.45801 18.8268 6.17806 18.5469 5.83301 18.5469Z"
        fill={stroke}
      />
      <path
        d="M19.166 13.5469C18.821 13.5469 18.541 13.8268 18.541 14.1719V18.5469H14.166C13.821 18.5469 13.541 18.8268 13.541 19.1719C13.541 19.5169 13.821 19.7969 14.166 19.7969H19.166C19.5111 19.7969 19.791 19.5169 19.791 19.1719V14.1719C19.791 13.8268 19.5111 13.5469 19.166 13.5469Z"
        fill={stroke}
      />
      <path
        d="M8.33268 3.54688H4.16602C3.82096 3.54688 3.54102 3.82682 3.54102 4.17188V8.33854C3.54102 8.68359 3.82096 8.96354 4.16602 8.96354H8.33268C8.67773 8.96354 8.95768 8.68359 8.95768 8.33854V4.17188C8.95768 3.82682 8.67773 3.54688 8.33268 3.54688ZM7.70768 4.79688V7.71354H4.79102V4.79688H7.70768Z"
        fill={stroke}
      />
      <path
        d="M11.666 8.96354H15.8327C16.1777 8.96354 16.4577 8.68359 16.4577 8.33854V4.17188C16.4577 3.82682 16.1777 3.54688 15.8327 3.54688H11.666C11.321 3.54688 11.041 3.82682 11.041 4.17188V8.33854C11.041 8.68359 11.321 8.96354 11.666 8.96354ZM12.291 7.71354V4.79688H15.2077V7.71354H12.291Z"
        fill={stroke}
      />
      <path
        d="M8.33268 11.0469H4.16602C3.82096 11.0469 3.54102 11.3268 3.54102 11.6719V15.8385C3.54102 16.1836 3.82096 16.4635 4.16602 16.4635H8.33268C8.67773 16.4635 8.95768 16.1836 8.95768 15.8385V11.6719C8.95768 11.3268 8.67773 11.0469 8.33268 11.0469ZM7.70768 12.2969V15.2135H4.79102V12.2969H7.70768Z"
        fill={stroke}
      />
      <path
        d="M15.208 15.8385C15.208 16.1836 15.488 16.4635 15.833 16.4635C16.1781 16.4635 16.458 16.1836 16.458 15.8385V11.6719C16.458 11.3268 16.1781 11.0469 15.833 11.0469C15.488 11.0469 15.208 11.3268 15.208 11.6719V13.1302H13.333C12.988 13.1302 12.708 13.4102 12.708 13.7552C12.708 14.1003 12.988 14.3802 13.333 14.3802H15.208V15.8385Z"
        fill={stroke}
      />
      <path
        d="M11.666 12.2969C12.0112 12.2969 12.291 12.0171 12.291 11.6719C12.291 11.3267 12.0112 11.0469 11.666 11.0469C11.3208 11.0469 11.041 11.3267 11.041 11.6719C11.041 12.0171 11.3208 12.2969 11.666 12.2969Z"
        fill={stroke}
      />
      <path
        d="M11.666 16.4609C12.0112 16.4609 12.291 16.1811 12.291 15.8359C12.291 15.4908 12.0112 15.2109 11.666 15.2109C11.3208 15.2109 11.041 15.4908 11.041 15.8359C11.041 16.1811 11.3208 16.4609 11.666 16.4609Z"
        fill={stroke}
      />
    </g>
    <defs>
      <clipPath id="clip0_1458_37967">
        <rect width="20" height="20" fill={fill} />
      </clipPath>
    </defs>
  </svg>
);

export const IconAgency = ({ size = 24, stroke = "#444", fill = "#fff" }) => (
  <svg
    height={size}
    width={size}
    version="1.1"
    id="Layer_1"
    viewBox="0 0 512 512"
  >
    <g>
      <path
        fill={fill}
        d="M327.696,481.12c-2.56,0-4.16-0.08-4.496-0.112l-31.472,0.032v-32h32.4
      c1.312-0.032,45.6,2.064,73.904-24.784c16.352-15.52,24.64-38.256,24.64-67.616h32c0,38.608-11.712,69.248-34.848,91.024
      C387.152,478.496,342.048,481.12,327.696,481.12z"
      />
      <path
        fill={fill}
        d="M457.12,172.768h-32C425.12,95.152,346.64,32,250.144,32c-96.464,0-174.96,63.152-174.96,140.768
      h-32C43.184,77.504,136.032,0,250.144,0S457.12,77.504,457.12,172.768z"
      />
    </g>
    <g>
      <path
        fill={fill}
        d="M101.2,372.64H47.44c-25.872,0-46.928-21.056-46.928-46.944V201.76
      c0-25.872,21.056-46.944,46.928-46.944h53.744c25.872,0,46.928,21.056,46.928,46.944v123.936
      C148.128,351.584,127.072,372.64,101.2,372.64z M47.44,186.832c-8.24,0-14.928,6.704-14.928,14.944v123.936
      c0,8.24,6.688,14.944,14.928,14.944h53.744c8.24,0,14.928-6.704,14.928-14.944V201.776c0-8.24-6.688-14.944-14.928-14.944H47.44z"
      />
      <path
        fill={fill}
        d="M464.544,372.64h-53.728c-25.872,0-46.944-21.056-46.944-46.944V201.76
      c0-25.872,21.056-46.944,46.944-46.944h53.728c25.872,0,46.944,21.056,46.944,46.944v123.936
      C511.472,351.584,490.416,372.64,464.544,372.64z M410.8,186.832c-8.24,0-14.944,6.704-14.944,14.944v123.936
      c0,8.24,6.704,14.944,14.944,14.944h53.728c8.24,0,14.944-6.704,14.944-14.944V201.776c0-8.24-6.704-14.944-14.944-14.944H410.8z"
      />
      <path
        fill={fill}
        d="M260.16,512h-37.232C197.056,512,176,490.944,176,465.072V449.52
      c0-25.872,21.056-46.944,46.928-46.944h37.232c25.888,0,46.944,21.056,46.944,46.944v15.552
      C307.104,490.944,286.048,512,260.16,512z M222.928,434.576c-8.24,0-14.928,6.704-14.928,14.944v15.552
      c0,8.224,6.704,14.928,14.928,14.928h37.232c8.24,0,14.944-6.704,14.944-14.944v-15.552c0-8.24-6.704-14.944-14.944-14.944h-37.232
      V434.576z"
      />
    </g>
  </svg>
);

export const DraggerIcon = ({
  size = 20,
  stroke = "#475467",
  strokeWidth = 1,
  fill = "#fff",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M12.5 10.8334C12.9602 10.8334 13.3333 10.4603 13.3333 10.0001C13.3333 9.53984 12.9602 9.16675 12.5 9.16675C12.0397 9.16675 11.6666 9.53984 11.6666 10.0001C11.6666 10.4603 12.0397 10.8334 12.5 10.8334Z"
      fill={fill}
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 5.83341C12.9602 5.83341 13.3333 5.46032 13.3333 5.00008C13.3333 4.53984 12.9602 4.16675 12.5 4.16675C12.0397 4.16675 11.6666 4.53984 11.6666 5.00008C11.6666 5.46032 12.0397 5.83341 12.5 5.83341Z"
      fill={fill}
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5 15.8334C12.9602 15.8334 13.3333 15.4603 13.3333 15.0001C13.3333 14.5398 12.9602 14.1667 12.5 14.1667C12.0397 14.1667 11.6666 14.5398 11.6666 15.0001C11.6666 15.4603 12.0397 15.8334 12.5 15.8334Z"
      fill={fill}
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.49996 10.8334C7.9602 10.8334 8.33329 10.4603 8.33329 10.0001C8.33329 9.53984 7.9602 9.16675 7.49996 9.16675C7.03972 9.16675 6.66663 9.53984 6.66663 10.0001C6.66663 10.4603 7.03972 10.8334 7.49996 10.8334Z"
      fill={fill}
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.49996 5.83341C7.9602 5.83341 8.33329 5.46032 8.33329 5.00008C8.33329 4.53984 7.9602 4.16675 7.49996 4.16675C7.03972 4.16675 6.66663 4.53984 6.66663 5.00008C6.66663 5.46032 7.03972 5.83341 7.49996 5.83341Z"
      fill={fill}
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.49996 15.8334C7.9602 15.8334 8.33329 15.4603 8.33329 15.0001C8.33329 14.5398 7.9602 14.1667 7.49996 14.1667C7.03972 14.1667 6.66663 14.5398 6.66663 15.0001C6.66663 15.4603 7.03972 15.8334 7.49996 15.8334Z"
      fill={fill}
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconVerticalLogo = ({
  fill = "white ",
  width = 145,
  height = 67,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 145 67"
    fill="none"
  >
    <path
      d="M65.3662 4.29554H62.7705V-0.000244141H72.5375V4.29554H69.9419V20.7593H65.3662V4.29554Z"
      fill={fill}
    />
    <path
      d="M73.3184 -0.000488281H77.9238V7.53429H79.5145V-0.000488281H84.1181V20.7591H79.5145V12.39H77.9238V20.7591H73.3184V-0.000488281Z"
      fill={fill}
    />
    <path
      d="M93.8037 -0.000488281V4.2953H89.7285V7.83835H92.9953V12.2472H89.7285V16.3762H93.9705V20.7609H85.1787V-0.000488281H93.8037Z"
      fill={fill}
    />
    <path
      d="M69.4097 22.8022H62.7686V43.7435H69.4394C72.1685 43.7435 73.6035 42.1935 73.6035 38.9305V27.4169C73.6054 24.0704 71.9998 22.8022 69.4097 22.8022ZM68.8757 38.454C68.8757 39.3254 68.6774 39.7221 68.0043 39.7221H67.3554V26.6846H68.0581C68.6773 26.6846 68.8757 27.0498 68.8757 27.8971V38.454Z"
      fill={fill}
    />
    <path
      d="M83.3201 22.8022V27.1388H79.2097V30.7152H82.5025V35.1612H79.2097V39.3254H83.487V43.7472H74.6191V22.8022H83.3201Z"
      fill={fill}
    />
    <path
      d="M84.0233 39.4108V36.0587H88.5843V38.9603C88.5843 39.663 88.7826 40.0579 89.3704 40.0579C89.9358 40.0579 90.1287 39.637 90.1287 38.8194V38.2558C90.1287 37.0432 90.0434 36.5371 89.0292 35.6101L86.6079 33.4408C84.8651 31.8909 84.2162 30.1778 84.2162 28.0382V27.0537C84.2162 24.2949 85.8755 22.5225 89.1145 22.5225H90.1546C93.5901 22.5225 94.799 24.1818 94.799 26.7997V29.3064H90.3196V27.0537C90.3196 26.4882 90.1806 26.1527 89.6169 26.1527C89.083 26.1527 88.9143 26.4901 88.9143 27.0834V27.6173C88.9143 28.4646 89.1127 28.9986 89.9284 29.7569L92.3201 31.8964C94.43 33.8116 95.0789 35.2726 95.0789 37.5253V38.5654C95.0789 41.8025 93.5049 44.0274 89.8988 44.0274H88.8846C85.6808 44.0274 84.0215 42.4477 84.0215 39.4071H84.0233V39.4108Z"
      fill={fill}
    />
    <path
      d="M100.516 43.7472H95.8721V22.8022H100.516V43.7491V43.7472Z"
      fill={fill}
    />
    <path
      d="M112.312 42.0787V35.1558C112.312 33.5817 111.268 32.7381 110.48 32.4267C111.298 32.0614 112.312 31.1882 112.312 29.2489V26.4901C112.312 24.0094 110.907 22.8005 108.851 22.8005H101.561V43.7474H106.201V35.1614H106.85C107.469 35.1614 107.638 35.4728 107.638 36.1755V42.2475C107.638 43.0058 107.807 43.486 108.003 43.7381H112.594V43.599C112.451 43.3191 112.312 42.8667 112.312 42.0787ZM107.642 30.2055C107.642 30.9379 107.384 31.2197 106.796 31.2197H106.21V26.4066H106.885C107.505 26.4066 107.644 26.6606 107.644 27.3911V30.2055H107.642Z"
      fill={fill}
    />
    <path
      d="M122.027 22.8022V27.1388H117.917V30.7152H121.21V35.1612H117.917V39.3254H122.196V43.7472H113.328V22.8022H122.027Z"
      fill={fill}
    />
    <path
      d="M69.2791 57.4674H73.7362L73.065 61.728C72.6701 64.3088 71.4668 66.8562 67.9071 66.8562H67.0932C63.1979 66.8562 62.0187 64.4738 62.497 61.3034L64.2083 50.652C64.7126 47.5391 66.0327 45.4106 69.6165 45.4106H70.4304C74.2127 45.4106 75.3084 47.5947 74.8579 50.3164L74.3258 53.6796H69.8687L70.4008 50.4555C70.4842 49.7546 70.347 49.4191 69.7556 49.4191C69.1641 49.4191 69.0269 49.7546 68.912 50.4555L67.1173 61.6686C67.0339 62.2842 67.2304 62.6791 67.7884 62.6791C68.3465 62.6791 68.4874 62.2582 68.632 61.5834L69.2791 57.4674Z"
      fill={fill}
    />
    <path
      d="M81.8378 45.4106H81.0276C77.4679 45.4106 76.1219 47.6837 75.5601 51.2972L74.0175 61.0271C73.4595 64.7537 75.2245 66.8562 78.7564 66.8562H79.6C82.6814 66.8562 84.4224 64.7816 85.0101 61.1662L86.5786 51.299C87.1089 47.7393 85.5663 45.4106 81.8378 45.4106ZM81.9546 50.8263L80.2452 61.5611C80.1618 62.0932 79.9356 62.5419 79.3182 62.5419C78.7027 62.5419 78.534 62.0932 78.6174 61.5314L80.299 50.8207C80.438 50.0364 80.6383 49.6471 81.2557 49.6471C81.8731 49.6471 82.0696 50.0698 81.9546 50.8263Z"
      fill={fill}
    />
    <path
      d="M88.4276 45.6907H93.6133L93.2499 55.4762L95.9123 45.6907H101.207L97.8998 66.5485H94.0045L95.8289 55.085L92.3229 66.5485H90.671L90.7544 55.085L88.93 66.5485H85.1182L88.4276 45.6907Z"
      fill={fill}
    />
    <path
      d="M108.415 45.6926H102.247L98.9395 66.5505H103.426L104.689 58.504H107.212C109.598 58.504 110.831 56.9614 111.252 54.2138L111.923 49.8994C112.34 47.0943 111.107 45.6926 108.415 45.6926ZM107.318 50.3722L106.814 53.6816C106.7 54.3825 106.534 54.6624 105.946 54.6624H105.33L106.168 49.3358H106.7C107.347 49.3358 107.431 49.7548 107.318 50.3722Z"
      fill={fill}
    />
    <path
      d="M114.527 45.6926L108.639 66.5505H112.619L113.378 63.495H115.452L115.313 66.5505H119.657L120.076 45.6926H114.527ZM115.677 59.3717L114.418 59.3735L115.986 53.0364L115.677 59.3717Z"
      fill={fill}
    />
    <path
      d="M127.731 45.6907L128.432 55.9527L130.058 45.6925H133.926L130.618 66.5504H126.662L125.736 55.4762L123.97 66.5504H120.074L123.384 45.6925L127.731 45.6907Z"
      fill={fill}
    />
    <path
      d="M139.954 58.5577L138.721 66.5467H134.205L135.468 58.6115L134.264 45.687H138.638L138.668 52.6118L140.852 45.687H144.999L139.954 58.5577Z"
      fill={fill}
    />
    <path
      d="M19.7939 -0.000244141V13.2431C25.0334 13.2487 30.056 15.3307 33.7604 19.0351C37.4647 22.7394 39.5486 27.762 39.5523 33.0015C39.5468 38.2391 37.4629 43.2617 33.7585 46.9661C30.0541 50.6704 25.0316 52.7525 19.7939 52.758V66.0032C37.9931 66.0032 52.8012 51.1969 52.8012 32.9959C52.8012 14.806 37.995 -0.000244141 19.7939 -0.000244141Z"
      fill={fill}
    />
    <path
      d="M19.7936 39.5536C18.0583 39.5518 16.3952 38.8602 15.1678 37.6329C13.9405 36.4055 13.2508 34.7424 13.2489 33.0071C13.2489 29.4028 16.1875 26.4642 19.7918 26.4642V13.219C14.5449 13.2246 9.51303 15.3122 5.80311 19.0221C2.09505 22.732 0.00741612 27.7639 0 33.0108C0.00556209 38.2595 2.0932 43.2895 5.80311 47.0013C9.51303 50.7112 14.5449 52.7988 19.7936 52.8044V39.5499V39.5536Z"
      fill={fill}
    />
  </svg>
);

export const IconAddGroup = ({ size = 18, fill = "#C6C6C6" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M1.04999 16.2C1.04994 16.6142 1.38569 16.95 1.7999 16.95C2.21412 16.9501 2.54994 16.6143 2.54999 16.2001L1.04999 16.2ZM1.80029 13.4997L2.55029 13.4998L1.80029 13.4997ZM9.44999 11.55C9.8642 11.55 10.2 11.2143 10.2 10.8C10.2 10.3858 9.8642 10.05 9.44999 10.05V11.55ZM16.2 12.45C16.6142 12.45 16.95 12.1143 16.95 11.7C16.95 11.2858 16.6142 10.95 16.2 10.95V12.45ZM12.15 10.95C11.7358 10.95 11.4 11.2858 11.4 11.7C11.4 12.1143 11.7358 12.45 12.15 12.45V10.95ZM13.425 13.7249C13.425 14.1392 13.7608 14.4749 14.175 14.4749C14.5892 14.4749 14.925 14.1392 14.925 13.7249H13.425ZM14.925 9.67494C14.925 9.26073 14.5892 8.92494 14.175 8.92494C13.7608 8.92494 13.425 9.26073 13.425 9.67494H14.925ZM13.4167 1.14582C13.0554 0.943285 12.5983 1.07201 12.3958 1.43333C12.1932 1.79465 12.3219 2.25175 12.6833 2.45428L13.4167 1.14582ZM12.6833 6.54582C12.3219 6.74835 12.1932 7.20545 12.3958 7.56677C12.5983 7.92809 13.0554 8.05681 13.4167 7.85428L12.6833 6.54582ZM10.05 4.50005C10.05 5.577 9.17694 6.45005 8.09999 6.45005V7.95005C10.0054 7.95005 11.55 6.40543 11.55 4.50005H10.05ZM8.09999 6.45005C7.02303 6.45005 6.14999 5.577 6.14999 4.50005H4.64999C4.64999 6.40543 6.1946 7.95005 8.09999 7.95005V6.45005ZM6.14999 4.50005C6.14999 3.42309 7.02303 2.55005 8.09999 2.55005V1.05005C6.1946 1.05005 4.64999 2.59467 4.64999 4.50005H6.14999ZM8.09999 2.55005C9.17694 2.55005 10.05 3.42309 10.05 4.50005H11.55C11.55 2.59467 10.0054 1.05005 8.09999 1.05005V2.55005ZM2.54999 16.2001L2.55029 13.4998L1.05029 13.4997L1.04999 16.2L2.54999 16.2001ZM4.50029 10.05C2.59506 10.05 1.05051 11.5944 1.05029 13.4997L2.55029 13.4998C2.55041 12.423 3.42342 11.55 4.50029 11.55V10.05ZM4.50029 11.55H9.44999V10.05H4.50029V11.55ZM16.2 10.95H14.175V12.45H16.2V10.95ZM14.175 10.95H12.15V12.45H14.175V10.95ZM14.925 13.7249V11.7H13.425V13.7249H14.925ZM14.925 11.7V9.67494H13.425V11.7H14.925ZM12.6833 2.45428C13.6115 2.97458 14.1 3.73929 14.1 4.50005H15.6C15.6 3.04812 14.6729 1.84994 13.4167 1.14582L12.6833 2.45428ZM14.1 4.50005C14.1 5.26081 13.6115 6.02552 12.6833 6.54582L13.4167 7.85428C14.6729 7.15016 15.6 5.95197 15.6 4.50005H14.1Z"
      fill={fill}
    />
  </svg>
);

export const IconRemoveGroup = ({ size = 18, fill = "#C6C6C6" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    enableBackground="new 0 0 18 18"
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="#e8eaed"
  >
    <rect fill="none" height={size} width={size} />
    <path d="M24,9v2h-6V9H24z M8,4C5.79,4,4,5.79,4,8s1.79,4,4,4s4-1.79,4-4S10.21,4,8,4z M8,13c-2.67,0-8,1.34-8,4v3h16v-3 C16,14.34,10.67,13,8,13z M12.51,4.05C13.43,5.11,14,6.49,14,8s-0.57,2.89-1.49,3.95C14.47,11.7,16,10.04,16,8S14.47,4.3,12.51,4.05 z M16.53,13.83C17.42,14.66,18,15.7,18,17v3h2v-3C20,15.55,18.41,14.49,16.53,13.83z" />
  </svg>
);

export const IconLock = ({
  width,
  height,
  size = 18,
  stroke = "#868686",
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || size}
    height={height || size}
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M4.95001 6.5998V5.91409C4.95001 3.63491 6.75643 1.7998 9.00001 1.7998C11.2436 1.7998 13.05 3.63491 13.05 5.91409V6.5998M4.95001 6.5998C4.20751 6.5998 3.60001 7.21695 3.60001 7.97123V14.8284C3.60001 15.5827 4.20751 16.1998 4.95001 16.1998H13.05C13.7925 16.1998 14.4 15.5827 14.4 14.8284V7.97123C14.4 7.21695 13.7925 6.5998 13.05 6.5998M4.95001 6.5998H13.05M9.00001 10.0284C9.74251 10.0284 10.35 10.6455 10.35 11.3998C10.35 12.1541 9.74251 12.7712 9.00001 12.7712C8.25751 12.7712 7.65001 12.1541 7.65001 11.3998C7.65001 10.6455 8.25751 10.0284 9.00001 10.0284Z"
      stroke={stroke}
      strokeWidth="1.5"
    />
  </svg>
);

export const IconCamera = ({
  width,
  height,
  size = 32,
  stroke = "#AB854A",
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || size}
    height={height || size}
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M16.1407 11.7779H12.474M21.167 19.1824L27.3669 22.2363C28.0096 22.6275 28.684 22.397 28.6667 21.581L28.6232 10.7882C28.5683 9.90239 28.0455 9.66068 27.2758 10.0701L21.1495 12.8543M7 24.6668H18.1407C19.7975 24.6668 21.1407 23.3403 21.1407 21.7039L21.167 17.9036L21.1407 10.2965C21.1407 8.66006 19.7975 7.3335 18.1407 7.3335H7C5.34315 7.3335 4 8.66006 4 10.2965V21.7039C4 23.3403 5.34315 24.6668 7 24.6668Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconDollar = ({
  width,
  height,
  size = 18,
  stroke = "#868686",
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || size}
    height={height || size}
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M12.5833 5.66667C12.4175 5.19603 12.1145 4.7858 11.7136 4.48878C11.3126 4.19176 10.8319 4.02153 10.3333 4H7C6.33696 4 5.70107 4.26339 5.23223 4.73223C4.76339 5.20107 4.5 5.83696 4.5 6.5C4.5 7.16304 4.76339 7.79893 5.23223 8.26777C5.70107 8.73661 6.33696 9 7 9H10.3333C10.9964 9 11.6323 9.26339 12.1011 9.73223C12.5699 10.2011 12.8333 10.837 12.8333 11.5C12.8333 12.163 12.5699 12.7989 12.1011 13.2678C11.6323 13.7366 10.9964 14 10.3333 14H7C6.50145 13.9785 6.02076 13.8082 5.61977 13.5112C5.21879 13.2142 4.91587 12.804 4.75 12.3333M8.66667 1.5V4M8.66667 14V16.5"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconBook = ({
  size = 24,
  height,
  width,
  fill = "",
  stroke = "#F2EBE2",
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || size}
    height={height || size}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M3.77142 5.14325C3.77142 3.62841 4.99944 2.40039 6.51428 2.40039H18.8571C20.372 2.40039 21.6 3.62841 21.6 5.14325V18.8575C21.6 20.3724 20.372 21.6004 18.8571 21.6004H6.51428C4.99944 21.6004 3.77142 20.3724 3.77142 18.8575V5.14325Z"
      fill={fill}
    />
    <path
      d="M8.57142 2.40039V21.6004M17.4857 10.629H12.6857M17.4857 6.51468H12.6857M5.14285 6.51468H2.39999M5.14285 10.629H2.39999M5.14285 14.7432H2.39999M6.51428 21.6004H18.8571C20.372 21.6004 21.6 20.3724 21.6 18.8575V5.14325C21.6 3.62841 20.372 2.40039 18.8571 2.40039H6.51428C4.99944 2.40039 3.77142 3.62841 3.77142 5.14325V18.8575C3.77142 20.3724 4.99944 21.6004 6.51428 21.6004Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const IconInActive = ({
  size = 24,
  height,
  width,
  stroke = "#F2EBE2",
}: IconProps) => (
  <svg
    fill={stroke}
    height={height || size}
    width={width || size}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g strokeWidth="0" />
    <g strokeLinecap="round" strokeLinejoin="round" />
    <g>
      <g>
        <path d="M13.6,23.9c-7.8,1-14.5-5.6-13.5-13.5c0.7-5.3,5-9.7,10.3-10.3c7.8-1,14.5,5.6,13.5,13.5C23.2,18.9,18.9,23.2,13.6,23.9z M13.7,2.1C6.9,1,1,6.9,2.1,13.7c0.7,4.1,4,7.5,8.2,8.2C17.1,23,23,17.1,21.9,10.3C21.2,6.2,17.8,2.8,13.7,2.1z" />
        <polyline points="5.6,4.2 19.8,18.3 18.4,19.8 4.2,5.6 " />
      </g>
    </g>
  </svg>
);

export const IconDash = ({
  height = 12,
  width = 12,
  size,
  fill = "e0e0e0",
}: IconProps) => (
  <svg
    height={height || size}
    width={width || size}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
  >
    <path
      fill={fill}
      d="M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
    />
  </svg>
);

export const IconCircledCheck = ({
  height = 65,
  width = 65,
  size,
  fill = "#1FCE7A",
  strokeWidth = 1.5,
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size || width}
    height={size || height}
    viewBox="0 0 65 65"
    fill="none"
  >
    <path
      d="M40.8787 27.1213L29.5 38.5L25.6213 34.6213M32.5 8.5C19.2452 8.5 8.5 19.2452 8.5 32.5C8.5 45.7548 19.2452 56.5 32.5 56.5C45.7548 56.5 56.5 45.7548 56.5 32.5C56.5 19.2452 45.7548 8.5 32.5 8.5Z"
      stroke={fill}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconCircledCross = ({
  height = 65,
  width = 65,
  size,
  fill = "#EB3E33",
  strokeWidth = 1.5,
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size || width}
    height={size || height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M15.7123 9.34835C16.0052 9.05546 16.0052 8.58058 15.7123 8.28769C15.4194 7.9948 14.9445 7.9948 14.6517 8.28769L15.7123 9.34835ZM8.28769 14.6517C7.9948 14.9445 7.9948 15.4194 8.28769 15.7123C8.58058 16.0052 9.05546 16.0052 9.34835 15.7123L8.28769 14.6517ZM14.6517 15.7123C14.9445 16.0052 15.4194 16.0052 15.7123 15.7123C16.0052 15.4194 16.0052 14.9445 15.7123 14.6517L14.6517 15.7123ZM9.34835 8.28769C9.05546 7.9948 8.58058 7.9948 8.28769 8.28769C7.9948 8.58058 7.9948 9.05546 8.28769 9.34835L9.34835 8.28769ZM20.25 12C20.25 16.5563 16.5563 20.25 12 20.25V21.75C17.3848 21.75 21.75 17.3848 21.75 12H20.25ZM12 20.25C7.44365 20.25 3.75 16.5563 3.75 12H2.25C2.25 17.3848 6.61522 21.75 12 21.75V20.25ZM3.75 12C3.75 7.44365 7.44365 3.75 12 3.75V2.25C6.61522 2.25 2.25 6.61522 2.25 12H3.75ZM12 3.75C16.5563 3.75 20.25 7.44365 20.25 12H21.75C21.75 6.61522 17.3848 2.25 12 2.25V3.75ZM14.6517 8.28769L11.4697 11.4697L12.5303 12.5303L15.7123 9.34835L14.6517 8.28769ZM11.4697 11.4697L8.28769 14.6517L9.34835 15.7123L12.5303 12.5303L11.4697 11.4697ZM15.7123 14.6517L12.5303 11.4697L11.4697 12.5303L14.6517 15.7123L15.7123 14.6517ZM12.5303 11.4697L9.34835 8.28769L8.28769 9.34835L11.4697 12.5303L12.5303 11.4697Z"
      fill={fill}
      strokeWidth={strokeWidth}
    />
  </svg>
);

export const IconCalendar = ({
  height = 16,
  width = 16,
  size,
  fill = "#8F6C32",
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size || width}
    height={size || height}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M3.16667 5.94284H12.5M4.37302 2V3.02869M11.1667 2V3.02857M13.1667 4.82857V12.2C13.1667 13.1941 12.3707 14 11.3889 14H4.27778C3.29594 14 2.5 13.1941 2.5 12.2V4.82857C2.5 3.83445 3.29594 3.02857 4.27778 3.02857H11.3889C12.3707 3.02857 13.1667 3.83445 13.1667 4.82857Z"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconCalendarSuccess = ({
  height = 16,
  width = 16,
  size,
  fill = "#1FCE7A",
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size || width}
    height={size || height}
    viewBox="0 0 65 65"
    fill="none"
  >
    <path
      d="M15.1667 24.2713H52.5M19.9921 8.5V12.6148M47.1667 8.5V12.6143M47.1667 12.6143H20.5C16.0817 12.6143 12.5 16.2983 12.5 20.8428V48.2715C12.5 52.816 16.0817 56.5 20.5 56.5H47.1667C51.5849 56.5 55.1667 52.816 55.1667 48.2715L55.1667 20.8428C55.1667 16.2983 51.5849 12.6143 47.1667 12.6143ZM27.1667 40.7285L31.1667 44.8428L40.5 35.2428"
      stroke={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconStar = ({
  height = 18,
  width = 18,
  size,
  fill = "#AB854A",
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size || width}
    height={size || height}
    viewBox="0 0 18 19"
    fill="none"
  >
    <path
      d="M8.6212 2.53621C8.77612 2.2223 9.22374 2.2223 9.37867 2.53621L11.3842 6.59981C11.4457 6.72446 11.5646 6.81086 11.7022 6.83085L16.1866 7.48248C16.533 7.53281 16.6714 7.95853 16.4207 8.20288L13.1757 11.3659C13.0762 11.463 13.0308 11.6028 13.0542 11.7398L13.8203 16.2061C13.8795 16.5511 13.5173 16.8142 13.2075 16.6513L9.19647 14.5426C9.07343 14.4779 8.92644 14.4779 8.8034 14.5426L4.79239 16.6513C4.48254 16.8142 4.12041 16.5511 4.17958 16.2061L4.94562 11.7398C4.96912 11.6028 4.92369 11.463 4.82415 11.3659L1.57918 8.20288C1.32851 7.95853 1.46683 7.53281 1.81325 7.48248L6.29769 6.83085C6.43525 6.81086 6.55417 6.72446 6.61569 6.59981L8.6212 2.53621Z"
      fill={fill}
    />
  </svg>
);

export const IconTimer = ({
  height = 24,
  width = 24,
  size,
  stroke = "#444",
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size || width}
    height={size || height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 9.84091V13.2175M9.5 2H14.5M20.5 13.4286C20.5 18.1624 16.6944 22 12 22C7.30558 22 3.5 18.1624 3.5 13.4286C3.5 8.6947 7.30558 4.85714 12 4.85714C16.6944 4.85714 20.5 8.6947 20.5 13.4286Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const IconChatMsgs = ({
  height = 64,
  width = 64,
  size,
  stroke = "#B0B0B0",
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size || width}
    height={size || height}
    viewBox="0 0 64 65"
    fill="none"
  >
    <path
      d="M13.3329 29.8333C13.3329 18.0513 22.8833 8.5 34.6644 8.5C46.4455 8.5 55.996 18.0513 55.996 29.8333C55.996 32.9001 55.3489 35.8157 54.1839 38.451L56 51.1646L45.1055 48.4408C42.0192 50.1766 38.4574 51.1667 34.6644 51.1667M8.00253 43.1667C8.00253 45.0834 8.40689 46.9056 9.13494 48.5527L8 56.4987L14.8084 54.7963C16.7371 55.8812 18.9631 56.5 21.3335 56.5C28.696 56.5 34.6644 50.5305 34.6644 43.1667C34.6644 35.8029 28.696 29.8333 21.3335 29.8333C13.971 29.8333 8.00253 35.8029 8.00253 43.1667Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconClock = ({
  height = 18,
  width = 18,
  size,
  stroke = "#727272",
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size || width}
    height={size || height}
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M9 7.38068V9.91315M7.125 1.5H10.875M15.375 10.0714C15.375 13.6218 12.5208 16.5 9 16.5C5.47918 16.5 2.625 13.6218 2.625 10.0714C2.625 6.52103 5.47918 3.64286 9 3.64286C12.5208 3.64286 15.375 6.52103 15.375 10.0714Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const IconInfo = ({
  height = 18,
  width = 18,
  size,
  stroke = "#727272",
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size || width}
    height={size || height}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10 10L10 13.75M10 7.22046V7.1875M2.5 10C2.5 5.85786 5.85787 2.5 10 2.5C14.1421 2.5 17.5 5.85787 17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconPage = ({
  height = 18,
  width = 18,
  size,
  stroke = "#B0B0B0",
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size || width}
    height={size || height}
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M11.2487 1.80078V4.50078C11.2487 4.99784 11.6517 5.40078 12.1487 5.40078H14.8487M6.29872 5.40078H8.09872M6.29872 8.10078H11.6987M6.29872 10.8008H11.6987M13.4987 3.15078C13.0982 2.79239 12.6825 2.36731 12.4201 2.09124C12.2455 1.90753 12.0042 1.80078 11.7508 1.80078H4.94851C3.9544 1.80078 3.14851 2.60666 3.14851 3.60077L3.14844 14.4007C3.14843 15.3948 3.95432 16.2007 4.94843 16.2007L13.0485 16.2008C14.0426 16.2008 14.8484 15.3949 14.8485 14.4008L14.8487 4.85916C14.8487 4.62903 14.7609 4.40781 14.6012 4.24213C14.3059 3.93577 13.8127 3.43167 13.4987 3.15078Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconLink = ({
  height = 24,
  width = 24,
  size,
  stroke = "#808080",
  strokeWidth = 1.5,
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size || width}
    height={size || height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M15 7H18C18.6566 7 19.3068 7.12933 19.9134 7.3806C20.52 7.63188 21.0712 8.00017 21.5355 8.46447C21.9998 8.92876 22.3681 9.47996 22.6194 10.0866C22.8707 10.6932 23 11.3434 23 12C23 12.6566 22.8707 13.3068 22.6194 13.9134C22.3681 14.52 21.9998 15.0712 21.5355 15.5355C21.0712 15.9998 20.52 16.3681 19.9134 16.6194C19.3068 16.8707 18.6566 17 18 17H15M9 17H6C5.34339 17 4.69321 16.8707 4.08658 16.6194C3.47995 16.3681 2.92876 15.9998 2.46447 15.5355C1.52678 14.5979 1 13.3261 1 12C1 10.6739 1.52678 9.40215 2.46447 8.46447C3.40215 7.52678 4.67392 7 6 7H9"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 12H16"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconAdd = ({ size = 14, stroke = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

export const IconConfirm = ({ size = 14, stroke = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

export const IconSparkles = ({ size = 18, stroke = "#C8A97E" }: { size?: number; stroke?: string }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 3l1.9 5.8a2 2 0 0 0 1.3 1.3L21 12l-5.8 1.9a2 2 0 0 0-1.3 1.3L12 21l-1.9-5.8a2 2 0 0 0-1.3-1.3L3 12l5.8-1.9a2 2 0 0 0 1.3-1.3z" />
  </svg>
);

export const IconChevron = ({ dir = "R", size = 14, stroke = "currentColor" }: { dir?: "L" | "R"; size?: number; stroke?: string }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    {dir === "R" ? <polyline points="9 18 15 12 9 6" /> : <polyline points="15 18 9 12 15 6" />}
  </svg>
);

export const IconRefresh = ({ size = 14, stroke = "currentColor" }: { size?: number; stroke?: string }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="23 4 23 10 17 10" />
    <polyline points="1 20 1 14 7 14" />
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
  </svg>
);

export const IconClose = ({ size = 14, stroke = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

export const IconChevronDown = ({ size = 14, stroke = "currentColor", open = false }: { size?: number; stroke?: string; open?: boolean }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={stroke}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={open ? "rotate-180 transition-transform" : "transition-transform"}
  >
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

export const IconTag = ({ width = 24, height = 24, stroke = "#B0B0B0" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M11.4142 2.75H4.75C3.64543 2.75 2.75 3.64543 2.75 4.75V11.4142C2.75 11.9446 2.96071 12.4533 3.33579 12.8284L11.1716 20.6642C11.9526 21.4453 13.2189 21.4453 14 20.6642L20.6642 14C21.4453 13.2189 21.4453 11.9526 20.6642 11.1716L12.8284 3.33579C12.4533 2.96071 11.9446 2.75 11.4142 2.75Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="7.75" cy="7.75" r="1.25" stroke={stroke} strokeWidth="1.5" />
  </svg>
);
